// import React from 'react';
// import { useInView } from 'react-intersection-observer';
// import nrLogo from  "./assets/office.jpeg" 

// export const Hero = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   return (
//     <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
//       {/* Background Image */}
//       <div 
//         className="absolute inset-0 bg-cover bg-center bg-no-repeat" 
//         style={{ 
          
//           // backgroundImage: "url('https://images.pexels.com/photos/5668859/pexels-photo-5668859.jpeg?auto=compress&cs=tinysrgb&w=1920')",
//           backgroundPosition: "center 25%",
//         }}
//       >
//         {/* Overlay */}
//         <div className="absolute inset-0 bg-navy-900 bg-opacity-70"></div>
//       </div>
      
//       <div 
//         ref={ref}
//         className={`container mx-auto px-4 md:px-6 text-center relative z-10 transform transition-all duration-1000 ${
//           inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//         }`}
//       >
//         <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
//           شركة مهنية مختصة بأعمال   <br />
//           <span className="text-navy-300"> المحاماة و الإستشارات  القانونية </span>
//         </h1>
//         <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto">
//           نقدم خدمات قانونية احترافية مع فريق من المحامين ذوي الخبرة لمساعدتك في حل قضاياك القانونية بكفاءة عالية
//         </p>
//         <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 rtl:space-x-reverse">
//           <a 
//             href="#contact" 
//             className="bg-navy-600 hover:bg-navy-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300 text-lg shadow-lg transform hover:-translate-y-1 hover:shadow-xl"
//             onClick={(e) => {
//               e.preventDefault();
//               document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
//             }}
//           >
//             تواصل معنا
//           </a>
//           <a 
//             href="#services" 
//             className="bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold py-3 px-8 rounded-lg transition-all duration-300 text-lg hover:shadow-lg transform hover:-translate-y-1"
//             onClick={(e) => {
//               e.preventDefault();
//               document.querySelector('#services').scrollIntoView({ behavior: 'smooth' });
//             }}
//           >
//             خدماتنا القانونية
//           </a>
//         </div>
//       </div>
//     </section>
//   );
// };


// import React from 'react';
// import { useInView } from 'react-intersection-observer';
// import nrLogo from "./assets/office.jpeg";

// export const Hero = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   return (
//     <section 
//       id="hero" 
//       className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 md:pt-28"
//       dir="rtl"
//     >
//       {/* صورة الخلفية مع تفعيل الرابط المحلي وتناسق الأبعاد */}
//       <div 
//         className="absolute inset-0 bg-cover bg-no-repeat transition-transform duration-10000 ease-out scale-105" 
//         style={{ 
//           backgroundImage: `url(${nrLogo})`,
//           backgroundPosition: "center 25%",
//         }}
//       >
//         {/* طبقة التعتيم الفاخرة المعتمدة على الـ Slate لعمق فخم وقراءة واضحة */}
//         <div className="absolute inset-0 bg-slate-950/80 backdrop-blur-[1px]"></div>
//       </div>
      
//       <div 
//         ref={ref}
//         className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 transform transition-all duration-1000 ${
//           inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//         }`}
//       >
//         {/* العنوان الرئيسي للمكتب المهني */}
//         <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
//           شركة مهنية مختصة بأعمال   <br className="hidden sm:inline" />
//           <span className="text-amber-400 bg-gradient-to-r from-amber-400 to-amber-200 bg-clip-text text-transparent">
//             المحاماة والاستشارات القانونية
//           </span>
//         </h1>

//         {/* النص الوصفي المساعد */}
//         <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-slate-300 mb-10 max-w-3xl mx-auto leading-relaxed font-light">
//           نقدّم حلولاً وخدمات قانونية مهنية واحترافية بكفاءة وموثوقية عالية
//         </p>

//         {/* أزرار التفاعل والإجراءات الحية */}
//         <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
//           <a 
//             href="#contact" 
//             className="w-full sm:w-auto bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold py-3.5 px-8 rounded-xl transition-all duration-300 text-base md:text-lg shadow-lg shadow-amber-500/10 transform hover:-translate-y-0.5 hover:shadow-xl hover:shadow-amber-500/20"
//             onClick={(e) => {
//               e.preventDefault();
//               const target = document.querySelector('#contact');
//               if (target) {
//                 const offset = document.querySelector('header')?.offsetHeight || 0;
//                 window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
//               }
//             }}
//           >
//             تواصل معنا
//           </a>
//           <a 
//             href="#services" 
//             className="w-full sm:w-auto bg-white/5 hover:bg-white/10 text-white border border-white/20 hover:border-white/40 font-medium py-3.5 px-8 rounded-xl backdrop-blur-sm transition-all duration-300 text-base md:text-lg transform hover:-translate-y-0.5"
//             onClick={(e) => {
//               e.preventDefault();
//               const target = document.querySelector('#services');
//               if (target) {
//                 const offset = document.querySelector('header')?.offsetHeight || 0;
//                 window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
//               }
//             }}
//           >
//             خدماتنا القانونية
//           </a>
//         </div>
//       </div>
//     </section>
//   );
// };



import React from 'react';
import { useInView } from 'react-intersection-observer';
import nrLogo from "./assets/office.webp";

export const Hero = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 md:pt-28 bg-white"
      dir="rtl"
    >
      {/* صورة الخلفية مع تفعيل الرابط المحلي وتناسق الأبعاد الفاتحة */}
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat transition-transform duration-10000 ease-out scale-105" 
        style={{ 
          backgroundImage: `url(${nrLogo})`,
          backgroundPosition: "center 25%",
        }}
      >
        {/* طبقة التراكب النظيفة والبيضاء الفاخرة لعمق ناصع وقراءة مثالية للنصوص الكحلية */}
        <div className="absolute inset-0 bg-white/85 backdrop-blur-[2px]"></div>
      </div>
      
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 transform transition-all duration-1000 ${
          inView ? 'translate-y-0 opacity-100' : 'translate-y-0 opacity-100'
        }`}
        // ref={ref}
        // className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 transform transition-all duration-1000 ${
        //   inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        // }`}
      >
        {/* العنوان الرئيسي للمكتب المهني باللون الكحلي الفخم والتدرج الحيوي */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 mb-6 leading-tight">
          شركة مهنية مختصة بأعمال <br className="hidden sm:inline" />
          <span className="bg-gradient-to-r from-indigo-950 to-blue-700 bg-clip-text text-transparent">
            المحاماة والاستشارات القانونية
          </span>
        </h1>

        {/* النص الوصفي المساعد */}
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-black mb-10 max-w-3xl mx-auto leading-relaxed font-light">
          نقدّم حلولاً وخدمات قانونية مهنية واحترافية بكفاءة وموثوقية عالية
        </p>

        {/* أزرار التفاعل والإجراءات الحية المحدثة بالكامل للهوية الجديدة */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          <a 
            href="#contact" 
            className="w-full sm:w-auto bg-indigo-950 hover:bg-indigo-900 text-white font-bold py-3.5 px-8 rounded-xl transition-all duration-300 text-base md:text-lg shadow-lg shadow-indigo-950/10 transform hover:-translate-y-0.5 hover:shadow-xl hover:shadow-indigo-950/20"
            onClick={(e) => {
              e.preventDefault();
              const target = document.querySelector('#contact');
              if (target) {
                const offset = document.querySelector('header')?.offsetHeight || 0;
                window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
              }
            }}
          >
            تواصل معنا
          </a>
          <a 
            href="#services" 
            className="w-full sm:w-auto bg-slate-100/80 hover:bg-slate-200 text-indigo-950 border border-slate-200 hover:border-indigo-950/20 font-semibold py-3.5 px-8 rounded-xl backdrop-blur-sm transition-all duration-300 text-base md:text-lg transform hover:-translate-y-0.5 shadow-sm"
            onClick={(e) => {
              e.preventDefault();
              const target = document.querySelector('#services');
              if (target) {
                const offset = document.querySelector('header')?.offsetHeight || 0;
                window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
              }
            }}
          >
            خدماتنا القانونية
          </a>
        </div>
      </div>
    </section>
  );
};